import { render, staticRenderFns } from "./ForMe.vue?vue&type=template&id=06ae9be4&scoped=true&"
import script from "./ForMe.vue?vue&type=script&lang=js&"
export * from "./ForMe.vue?vue&type=script&lang=js&"
import style0 from "./ForMe.vue?vue&type=style&index=0&id=06ae9be4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae9be4",
  null
  
)

export default component.exports